// @flow
import { propSatisfies, equals } from 'ramda'

import { isNotEmpty } from '@alphaott/common-utils/utils/help'

export type LimitError = {
  code: string,
  message: string,
  limits: {
    devices: {
      STB: number,
      MOBILE: number,
    },
    total: number,
  },
}

const EXCEED_CODE = 'ExceededDeviceLimit'

export const isExceedLimit = propSatisfies(equals(EXCEED_CODE), 'code')
export const isExist = (value: any) => value && isNotEmpty(value)

// eslint-disable-next-line complexity
export const getLimitsError = (limitError: LimitError, t: Function): ?Object => {
  if (isExist(limitError) && isExceedLimit(limitError)) {
    const { limits } = limitError

    return {
      ...limitError,
      error: t('error_code', { code: 403 }),
      subTitle: t('error_device_limit_exceeded', {
        total: limits?.total || 0,
        stb: limits?.devices?.STB || 0,
        mobile: limits?.devices?.MOBILE || 0,
      }),
    }
  }
  return null
}
